import {Fragment} from 'react';

import {TenantSettingService as Service} from './TenantSettingService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';

export const List = () => {

  const header = 'Tham số hệ thống';
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'key', header: 'Mã', width: 200},
      {field: 'description', header: 'Diễn giải', minWidth: 200},
      {field: 'value', header: 'Giá trị', width: 200}
    ],
    actionColumnWidth: 0,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '50rem',
    fields: [
      {field: 'key', header: 'Mã', required: true, InputTextProps: {maxLength: 250}, className: 'md:col-12'},
      {field: 'description', header: 'Diễn giải', required: true, InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'value', header: 'Giá trị', InputTextProps: {maxLength: 500}, className: 'md:col-12'}
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
